module.exports = __webpack_public_path__ + "static/media/matlab.7c6f889c.svg";